import { getEnv } from "../helpers/general";
import { GraphQLClient } from "graphql-request";

const BASE = getEnv("REACT_APP_API_URL");

export const GRAPHQL_API = getEnv("REACT_APP_GRAPHQL_API_URL");

export const CATEGORIES = BASE + "/categories/";
export const CATEGORY_FAQ = (id) => BASE + `/categories/${id}/faqs/`;

export const LOGIN = BASE + "/users/";
export const LOGIN_RESEND = BASE + "/users/resend/";
export const LOGIN_CHECK = BASE + "/users/try/";

export const PROFILE = BASE + "/users/profile/";
export const PROFILE_EDIT = BASE + "/users/profile/";
export const ADDRESS = BASE + "/users/addresses/";
export const ADDRESS_DELETE = (id) => `${BASE}/users/addresses/${id}`;
export const PROFILE_ADD_CREDIT = `${BASE}/users/add-fund/`;

export const ORDERS_LIST = BASE + "/orders/?page_size=-1";
export const ORDERS_CREATE = BASE + "/orders/";
export const ORDERS_ACTIVE = BASE + "/orders/active/";
export const ORDERS_WORK_DONE = BASE + "/orders/work-done/";
export const ORDERS_ACTIVE_WORKS = BASE + "/orders/active-works/";
export const ORDERS_CHANGE_QUANTITY = (order_id) =>
  `${BASE}/orders/${order_id}/add-item/`;
export const ORDERS_SET_COLLECTION = (order_id) =>
  `${BASE}/orders/${order_id}/set-collection/`;
export const ORDERS_SET_DELIVERY = (order_id) =>
  `${BASE}/orders/${order_id}/set-delivery/`;
export const ORDERS_SINGLE = (id) => `${BASE}/orders/${id}`;
export const ORDERS_COUPON_ADD = (id) => `${BASE}/orders/${id}/add-coupon/`;
export const ORDERS_COUPON_REMOVE = (id) =>
  `${BASE}/orders/${id}/remove-coupon/`;

export const LOGISTIC_TIMESHEETS = BASE + "/transportation/time-sheet/";
export const TRANSACTIONS_LIST = BASE + "/transactions/?page_size=-1";

// Deprecated
export const COLLECTION_TIME = BASE + "/invoices/collection-time/";
export const DELIVERY_TIME = BASE + "/invoices/delivery-time/";
export const SUBMIT_ORDER = BASE + "/invoices/orders/";

export const ADD_CHARGE = BASE + "/wallet/add-fund/";

export const CHECK_FOR_UPDATE = BASE + "/common/check-update/";
export const gqlClient = new GraphQLClient(GRAPHQL_API);
